// text-reveal.js

export const createTextReveal = (config = {}) => {
	const settings = {
		selector: '.intro-text-color-reveal',
		delay: 30,
		fromColor: '#a2a7ae',
		toColor: 'white',
		autoStartDelay: 3000,
		scrollTriggerOffset: 800,
		...config,
	};

	const element = document.querySelector(settings.selector);
	let isStarted = false;

	if (!element) {
		console.warn(`No element found with selector "${settings.selector}"`);
		return;
	}

	const isInViewport = () => {
		const rect = element.getBoundingClientRect();
		return (
			rect.top >= -settings.scrollTriggerOffset &&
			rect.bottom <=
				(window.innerHeight || document.documentElement.clientHeight) +
					settings.scrollTriggerOffset
		);
	};

	const setupContent = () => {
		const htmlContent = element.innerHTML.trim();
		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = htmlContent;

		const nodes = Array.from(tempDiv.childNodes).map((node) => {
			if (node.nodeType === Node.TEXT_NODE) return node.textContent;
			if (node.nodeName === 'BR') return '<br/>';
			return '';
		});

		const wrappedContent = nodes
			.map((node) => (node === '<br/>' ? node : `<span>${node}</span>`))
			.join('');

		element.innerHTML = wrappedContent;
	};

	const animateLine = (spans, spanIndex, charIndex) => {
		if (spanIndex >= spans.length) return;

		const span = spans[spanIndex];
		const chars = span.textContent.split('');

		if (charIndex <= chars.length) {
			span.innerHTML =
				`<span style="color: ${settings.toColor}">${chars.slice(0, charIndex).join('')}</span>` +
				`<span style="color: ${settings.fromColor}">${chars.slice(charIndex).join('')}</span>`;

			setTimeout(
				() => animateLine(spans, spanIndex, charIndex + 1),
				settings.delay,
			);
		} else {
			setTimeout(() => animateLine(spans, spanIndex + 1, 0), 0);
		}
	};

	const start = () => {
		if (isStarted) return;
		isStarted = true;
		const spans = element.querySelectorAll('span');
		animateLine(spans, 0, 0);
	};

	setupContent();

	document.addEventListener('scroll', () => {
		if (!isStarted && isInViewport()) start();
	});

	setTimeout(() => {
		if (!isStarted) start();
	}, settings.autoStartDelay);

	start();
};

export default createTextReveal;
